import { Container, Card, Row, Col } from "react-bootstrap"
import { useState } from "react"
// import { useParams } from "react-router-dom"
// import { useCallback, useEffect } from "react"

export default function AgendaTemplates() {

  const [isCollapsed, setIsCollapsed] = useState(true)

  const toggleCollapse = () => {
    setIsCollapsed(prev => {
      const next = !prev;
      if (next === false) {
        // fetchTimers();
      }
      return next;
    });
  };

  // const url = process.env.REACT_APP_URL;
  // const meetingId = useParams().meetingId;
  // const [isLoading, setIsLoading] = useState(false);
  // const [timers, setTimers] = useState([]);

  // const formatTime = (time) => {
  //   const minutes = Math.floor(time / 60);
  //   const seconds = time % 60;
  //   return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
  // };

  // const fetchTimers = useCallback(async () => {
  //   // setIsLoading(true);
  //   try {
  //     const response = await fetch(`${url}/timers/${meetingId}`, {
  //       method: 'GET',
  //       headers: {
  //         'Content-Type': 'application/json',
  //       }
  //     });
  //     if (response.ok) {
  //       const data = await response.json();
  //       // console.log(data)
  //       setTimers(data);
  //     } else {
  //       console.error('Failed to fetch timers');
  //     }
  //   } catch (error) {
  //     console.error('Error fetching timers:', error);
  //   }
  //   // setIsLoading(false);
  // }, [url, meetingId])

  // useEffect(() => {
  //   fetchTimers();
  //   // console.log(timers)
  // }, [fetchTimers]);

  // const getBackgroundColor = (timer) => {
  //   if (parseInt(timer.time) > convertToSeconds(timer.agendaItem.agendaEvent.red) + 30) return 'black'
  //   else if (parseInt(timer.time) >= convertToSeconds(timer.agendaItem.agendaEvent.red)) return '#dc3545'
  //   else if (parseInt(timer.time) >= convertToSeconds(timer.agendaItem.agendaEvent.amber)) return '#ffc107'
  //   else if (parseInt(timer.time) >= convertToSeconds(timer.agendaItem.agendaEvent.green)) return '#146c43'
  //   return 'black';
  // };

  // const getForegroundColor = (timer) => {
  //   if (parseInt(timer.time) > convertToSeconds(timer.agendaItem.agendaEvent.red) + 30) return '#ffffff'
  //   else if (parseInt(timer.time) >= convertToSeconds(timer.agendaItem.agendaEvent.red)) return '#ffffff'
  //   else if (parseInt(timer.time) >= convertToSeconds(timer.agendaItem.agendaEvent.amber)) return '#000000'
  //   else if (parseInt(timer.time) >= convertToSeconds(timer.agendaItem.agendaEvent.green)) return '#ffffff'
  //   return 'ffffff';
  // };

  // const convertToSeconds = (timeString) => {
  //   const [minutes, seconds] = timeString.split(':').map(Number)
  //   return minutes * 60 + seconds
  // }

  return (
    <Container>
      <Card id="timer" className="mb-3 mt-3">
        <Card.Header onClick={toggleCollapse} style={{ cursor: 'pointer', paddingTop: '5px' }}>
          <Row className="header mb-2">
            <Col xs={11} className="title">
              <h5>Agenda Templates</h5>
            </Col>
            <Col xs={1} lg={1}>
              <i className={`bi ${isCollapsed ? 'bi-caret-down-fill' : 'bi-caret-up-fill'}`}></i>
            </Col>
          </Row>
        </Card.Header>
        {!isCollapsed && (
          <>
            <Card.Body className="to-left">
              <Row>
                <Col>
                  {/* <Button
                    variant="primary"
                    type='submit'
                    className='assignments-button w-100 mb-3'
                    onClick={fetchTimers}
                  >
                    Reload Timers <i className="bi bi-arrow-clockwise" />
                  </Button> */}
                </Col>
              </Row>
              <Row>
                <Col>
                </Col>
              </Row>
            </Card.Body>
            <Card.Footer>
              <Row>
                <Col xs={12} lg={12}>
                  <p className="float-end">Agenda Templates</p>
                </Col>
              </Row>
            </Card.Footer>
          </>
        )}
      </Card>
    </Container>
  )
}